// @flow

function assert(condition: boolean, message: string) {
  if (!condition) {
    throw new Error(`Assertion failure: ${message}`);
  }
}

module.exports = assert;



// WEBPACK FOOTER //
// /Users/jlaster/src/mozilla/devtools-core/packages/devtools-source-map/src/assert.js